package co.uk.sacursoftware.ssinventory.util

import androidx.compose.runtime.compositionLocalOf

enum class UserRole {
    ADMIN,
    EDITOR,
    SHOP
}

val LocalUserRole = compositionLocalOf { UserRole.SHOP }
